import { FieldArrayRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import React, { useRef } from "react";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";

import { Button } from "@progress/kendo-react-buttons";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { CustomAppDialog } from "../../components/dialog/Dialog";
import { LoadingPanel } from "../../components/layout/Loading";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { ImCross } from "react-icons/im";
import { findAllOrder, findbyOrderNo } from "../order/services/order.services";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { MdOutlineImageNotSupported } from "react-icons/md";
import { FaRegEye } from "react-icons/fa";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";
import { clearFilterOrder, setFilterOrder } from "../order/orderSlice";
import { closeDullOrderSelectionDialog } from "./dullSlice";
import { FetchWeight } from "../palish/services/palish.services";
import { PROCESS_ID } from "../../_contstants/common";

interface SelectDialogProps {
  fieldArrayRenderProps: FieldArrayRenderProps;
}

const DullOrderSelectionDialog = ({
  fieldArrayRenderProps,
}: SelectDialogProps) => {
  const orderList = useAppSelector((state) => state.order.OrderList);
  const DullOrderSelectionDialog = useAppSelector(
    (state) => state.dull.DullOrderSelectionDialog,
  );
  const DullOrderItemIndex = useAppSelector(
    (state) => state.dull.DullOrderItemIndex,
  );

  const fieldname = fieldArrayRenderProps.name;
  const dispatch = useAppDispatch();

  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const loading = useAppSelector((state) => state.order.loading);
  const gridRef = useRef<any>(null);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyImageCommandCell = (props: GridCellProps) => {
    const handlClickItem = (image: string) => {
      if (image && typeof image === "string") {
        window.open(image);
      }
    };
    if (props.dataItem?.image === null) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "50px",
          }}
        >
          <MdOutlineImageNotSupported style={{ fontSize: "30px" }} />
          <p style={{ margin: 0, fontSize: "12px" }}>No Image!</p>
        </div>
      );
    }
    return (
      <td className="action-td main-image">
        <div
          style={{
            position: "relative",
            border: "1px dotted lightgrey",
            borderRadius: "5px",
            height: "50px",
            overflow: "hidden",
          }}
        >
          <img
            className="product-image"
            src={props.dataItem?.image_name}
            alt=""
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
              borderRadius: "5px",
            }}
          />
          <div className="image-view">
            <FaRegEye
              style={{
                color: "white",
                height: 24,
                width: 24,
                cursor: "pointer",
              }}
              onClick={() => handlClickItem(props.dataItem?.image_name)}
            />
          </div>
        </div>
      </td>
    );
  };

  const MyEditCommandCell = (props: any) => {
    const handleSelectOrder = async (order_no: number) => {
      const getOrderNowiseData = async () => {
        try {
          const res = await dispatch(
            findbyOrderNo({ order_no, process_id: PROCESS_ID.dull }),
          );
          const updateField = (field: any, value: any) =>
            fieldArrayRenderProps.formRenderProps?.onChange(
              `${fieldname}.${DullOrderItemIndex}.${field}`,
              { value },
            );
          const prev_process_id =
            fieldArrayRenderProps.formRenderProps?.valueGetter(
              `${fieldname}.${DullOrderItemIndex}.previous_process_id`,
            );
          const karigar_id =
            fieldArrayRenderProps.formRenderProps?.valueGetter(`karigar_id`);
          const payload = {
            process_id: prev_process_id,
            order_id: res?.payload?.id,
            karigar_id: karigar_id,
          };
          if (res.meta.requestStatus === "fulfilled" && res) {
            updateField("order_id", res?.payload?.id);
            updateField("order_no", res?.payload?.order_no);
            updateField("item_id", res?.payload?.item_id);
            updateField("item_description", res?.payload?.description);
            updateField("remarks", "");
            const response = await dispatch(FetchWeight(payload));
            if (response?.meta?.requestStatus === "fulfilled") {
              updateField("weight", response.payload.Data[0].gross_weight || 0);
            } else {
              updateField("weight", 0);
            }
          }
        } catch (error) {
          console.error(error);
        }
      };
      if (order_no) {
        await getOrderNowiseData();
        dispatch(closeDullOrderSelectionDialog());
      }
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        <Button
          type="button"
          fillMode="solid"
          themeColor={"primary"}
          size="small"
          title="Select Order"
          onClick={() => handleSelectOrder(props.dataItem?.order_no)}
        >
          Select
        </Button>
      </td>
    );
  };
  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };
  // const onSelectionChange = React.useCallback(
  //   (event: GridSelectionChangeEvent) => {
  //     const newSelectedState = getSelectedState({
  //       event,
  //       selectedState: selectedState,
  //       dataItemKey: DATA_ITEM_KEY,
  //     });
  //     setSelectedState(newSelectedState);
  //     const trueKeys = Object.keys(newSelectedState)
  //       .filter((key) => newSelectedState[key])
  //       .map(String);
  //     setRowSelectionModel(trueKeys);
  //   },
  //   [selectedState]
  // );
  // const onHeaderSelectionChange = React.useCallback(
  //   (event: GridHeaderSelectionChangeEvent) => {
  //     const checkboxElement: any = event.syntheticEvent.target;
  //     const checked = checkboxElement.checked;
  //     const newSelectedState: { [key: string]: boolean } = {};

  //     event.dataItems.forEach((item) => {
  //       newSelectedState[idGetter(item)] = checked;
  //     });
  //     setSelectedState(newSelectedState);
  //     const trueKeys = Object.keys(newSelectedState)
  //       .filter((key: string) => newSelectedState[key])
  //       .map(String);
  //     setRowSelectionModel(trueKeys);
  //   },
  //   []
  // );

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 0 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const OrderFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        filterSelector={(state) => state.order.FilterOrder}
        setFilterAction={setFilterOrder}
        clearFilterAction={clearFilterOrder}
        fetchDataAction={findAllOrder}
        pagination={{ case: "lowercase" }}
        extraPayload={{ ProcessID: PROCESS_ID.dull }}
      />
    ),
    [],
  );

  // const handleSelectMultiOrder = () => {
  //   const getOrderNowiseData = async (order_no: any) => {
  //     try {
  //       const res = await dispatch(findbyOrderNo(+order_no));
  //       if (res.meta.requestStatus === "fulfilled" && res) {
  //         const order = {
  //           previous_process_id: null,
  //           order_id: res?.payload?.id,
  //           order_no: res?.payload?.order_no,
  //           item_id: res?.payload?.item_id,
  //           item_description: res?.payload?.description,
  //           weight: res?.payload?.weight,
  //           remarks: "",
  //         };
  //         pushElementInarray(order);
  //       }
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };
  //   rowSelectionModel?.forEach((order: string) => {
  //     getOrderNowiseData(order);
  //   });
  //   setRowSelectionModel([]);
  //   setSelectedState({});
  //   dispatch(closeDullOrderSelectionDialog());
  // };
  return (
    <>
      <CustomAppDialog open={DullOrderSelectionDialog}>
        <div style={{ width: "70vw", minHeight: "30vh" }}>
          {loading && <LoadingPanel gridRef={gridRef} />}
          <GridLayout gap={{ rows: 10, cols: 10 }}>
            <GridLayoutItem
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography.h4>{"Select Order"}</Typography.h4>

              <ImCross
                style={{
                  color: "white",
                  background: "red",
                  borderRadius: "50%",
                  padding: "5px",
                  fontSize: "24px",
                }}
                onClick={() => dispatch(closeDullOrderSelectionDialog())}
              />
            </GridLayoutItem>

            {/* <GridLayoutItem
              style={{
                gridArea: "auto",
                display: "flex",
                alignItems: "end",
                justifyContent: "end",
                marginRight: "15px",
              }}
            >
              {rowSelectionModel.length > 0 && (
                <Button
                  type="button"
                  fillMode="solid"
                  themeColor={"primary"}
                  size="small"
                  title="Select Checked Order"
                  onClick={handleSelectMultiOrder}
                >
                  Select Checked
                </Button>
              )}
            </GridLayoutItem> */}
            <GridLayoutItem style={{ overflow: "hidden" }}>
              <KendoGrid
                className="selection-dialog responsive-table"
                // dataItemKey={DATA_ITEM_KEY}
                style={{ maxHeight: "calc(100vh - 152px)" }}
                filterable={true}
                filter={filter}
                data={filter ? filterBy(orderList, filter) : orderList}
                total={orderList[0]?.itemcount || orderList.length}
                onFilterChange={handleFilterChange}
                skip={currentPage * pageLimit}
                take={pageLimit}
                pageable={{
                  buttonCount: 5,
                  pageSizes: [10, 50, 100, 300, 500],
                  pageSizeValue: pageLimit,
                  type: "input",
                }}
                onPageChange={pageChange}
                // selectable={true}
                // select={selectedState}
                // onSelectionChange={onSelectionChange}
                // onHeaderSelectionChange={onHeaderSelectionChange}
                cells={{
                  headerCell: HeaderCustomCell,
                  data: MyDataCustomCell,
                }}
              >
                {/* <Column
                  filterable={false}
                  columnType="checkbox"
                  width={42}
                  locked={true}
                  headerSelectionValue={
                    dataState?.findIndex(
                      (item: any) => !selectedState[idGetter(item)]
                    ) === -1
                  }
                /> */}
                <Column
                  field="image_name"
                  title="Image"
                  width={100}
                  cells={{
                    data: MyImageCommandCell,
                  }}
                  filterable={false}
                  // locked={true}
                />
                <Column
                  field="order_no"
                  title="Order No"
                  width={100}
                  filterable={false}
                  cells={{
                    data: (props: any) => (
                      <td>
                        <div style={{ color: "green" }}>
                          <strong>
                            {props.dataItem?.order_no}
                            {props.dataItem?.ordersub_no
                              ? `.${props.dataItem?.ordersub_no}`
                              : ""}
                          </strong>
                        </div>
                      </td>
                    ),
                  }}
                />
                <Column
                  width={200}
                  field="party_name"
                  title="Party Name"
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  width={200}
                  field="item_name"
                  title="Product Name"
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  width={130}
                  field="order_date"
                  title="Order Date"
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  width={130}
                  field="delivery_date"
                  title="Delivery Date"
                  cells={{ filterCell: OrderFilterCell }}
                />
                <Column
                  field="order_no"
                  title="Actions"
                  cells={{ data: MyEditCommandCell }}
                  width={"90px"}
                  filterable={false}
                  locked={true}
                />
              </KendoGrid>
            </GridLayoutItem>
          </GridLayout>
        </div>
      </CustomAppDialog>
    </>
  );
};

export default DullOrderSelectionDialog;
